<template>
  <div class="pr-1 sm:overflow-auto md:overflow-hidden lg:overflow-hidden">
    <h1>Admin</h1>
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      <Link
        :href="route('admin.impersonate')"
        class="relative items-center flex justify-center overflow-hidden rounded-lg bg-white hover:bg-gray-100 p-5 shadow sm:p-4">
        <dt>
          <p class="text-sm font-medium text-gray-500">
            User Impersonation
          </p>
        </dt>
      </Link>
    </dl>
  </div>
</template>

<script setup>
/* external */
import { Link } from '@inertiajs/vue3';

/* local */

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */
defineProps({
  users: {
    type: Array,
    required: true,
  },
});

</script>
